import { Badge, Group, Text } from '@mantine/core'
import { calculateFinalPrice, formatEuros } from '@markku/utils'

interface PriceDisplayProps {
  basePrice: string | number | null | undefined
  discountPercent?: number | null
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function PriceDisplay({
  basePrice,
  discountPercent,
  size = 'sm',
}: PriceDisplayProps) {
  const hasDiscount = discountPercent != null && discountPercent > 0
  const finalPrice = calculateFinalPrice(basePrice, discountPercent)

  if (!hasDiscount) {
    return (
      <Text size={size} fw={500}>
        {formatEuros(finalPrice)}
      </Text>
    )
  }

  return (
    <Group gap="xs" wrap="nowrap">
      <Text size={size} c="dimmed" td="line-through">
        {formatEuros(basePrice)}
      </Text>
      <Badge size="xs" variant="light" color="green">
        -{discountPercent}%
      </Badge>
      <Text size={size} fw={500}>
        {formatEuros(finalPrice)}
      </Text>
    </Group>
  )
}
